var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyTagsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "95px",
    height: "92px",
    viewBox: "0 0 95 92",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 26") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.34,1.683 C-2.292,9.492 -0.738,21.097 3.523,32.269 L3.523,32.269 C12.698,49.573 24.981,64.16 40.372,76.026 L40.372,76.026 C57.674,86.28 69.231,83.298 75.045,67.08 L75.045,67.08 C76.913,46.997 62.152,39.429 47.896,34.998 L47.896,34.998 C38.392,32.042 32.402,27.401 29.927,21.072 L29.927,21.072 C21.649,7.262 15.184,0.356 10.528,0.356 L10.528,0.356 C9.349,0.357 8.287,0.799 7.34,1.683 L7.34,1.683 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.649,0.4 C24.044,0.4 30.849,7.026 30.849,15.2 C30.849,23.374 24.044,30 15.649,30 C7.255,30 0.449,23.374 0.449,15.2 C0.449,7.026 7.255,0.4 15.649,0.4 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.649,0.4 L15.9670226,0.403175242 C24.2151881,0.568019869 30.849,7.1304557 30.849,15.2 L30.849,15.2 L30.8457395,15.5096507 C30.6764668,23.5406851 23.9377342,30 15.649,30 L15.649,30 L15.3310144,29.9968252 C7.08378673,29.8320051 0.449,23.2705316 0.449,15.2 C0.449,7.027 7.255,0.4 15.649,0.4 L15.649,0.4 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.691,0.985 C38.657,0.987 27.143,9.937 20.538,15.011 L20.538,15.011 C13.683,20.277 11.94,24.695 15.307,28.262 L15.307,28.262 C17.921,28.874 19.776,30.48 20.869,33.078 L20.869,33.078 C21.88,38.961 13.828,52.786 4.726,63.299 L4.726,63.299 C-1.343,70.307 -1.038,76.109 5.639,80.703 L5.639,80.703 C11.118,84.114 15.623,83.782 19.152,79.705 L19.152,79.705 C22.682,75.629 33.552,63.077 51.76,42.047 L51.76,42.047 C62.712,28.916 66.445,18.737 62.963,11.51 L62.963,11.51 C59.398,3.757 54.276,0.985 48.693,0.985 L48.693,0.985 C48.692,0.985 48.692,0.985 48.691,0.985 L48.691,0.985 Z",
    id: "path-7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Empty-States",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Uploads/-Gallery/-EmptyState-NoTags",
    transform: "translate(-234.000000, -321.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(234.000000, 321.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    opacity: 0.2,
    transform: "translate(0.000000, 9.364000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#00FFA6",
    mask: "url(#mask-2)",
    points: "-20.0442 19.434 19.6078 -16.033 91.3428 64.166 51.6898 99.633"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    opacity: 0.2,
    transform: "translate(64.000000, 18.364000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6491,29.9999 C24.0441,29.9999 30.8491,23.3739 30.8491,15.1999 C30.8491,7.0259 24.0441,0.3999 15.6491,0.3999 C7.2541,0.3999 0.4491,7.0259 0.4491,15.1999 C0.4491,23.3739 7.2541,29.9999 15.6491,29.9999",
    id: "Fill-4",
    fill: "#00FFA6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-7"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#00FFA6",
    mask: "url(#mask-4)",
    points: "-74.351 597 153.649 597 153.649 -151 -74.351 -151"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-10"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    fill: "#00FFA6",
    mask: "url(#mask-6)",
    points: "-4.551 35 35.849 35 35.849 -4.6 -4.551 -4.6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    opacity: 0.2,
    transform: "translate(19.000000, 0.364000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-14"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-13",
    fill: "#3AACE2",
    mask: "url(#mask-8)",
    points: "-26.0657 60.0815 40.7903 -17.1285 80.1593 16.9605 13.3013 94.1705"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(23.000000, 26.364000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.8757,14.7363 C2.8717,14.7243 2.8677,14.7123 2.8647,14.7003 C2.4747,13.3913 3.2187,12.0143 4.5267,11.6233 L30.8567,3.5493 C31.4807,3.3773 32.1467,3.4323 32.7327,3.7063 L32.7877,3.7353 L45.8007,11.1293 L40.0327,12.8983 C39.5167,12.0393 38.7787,11.3343 37.8977,10.8553 C37.8617,10.8353 37.8257,10.8163 37.7887,10.7983 C35.1197,9.4193 31.8377,10.4663 30.4597,13.1363 C29.0817,15.8063 30.1287,19.0873 32.7987,20.4653 C35.4677,21.8433 38.7497,20.7973 40.1277,18.1273 C40.5897,17.2363 40.8047,16.2393 40.7507,15.2383 L46.5187,13.4703 L39.9167,26.8333 C39.6017,27.4493 39.0527,27.9143 38.3927,28.1243 L12.0637,36.1973 C10.7537,36.5433 9.3977,35.8243 8.9497,34.5463 L2.8757,14.7363 Z",
    id: "Fill-16",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8405,12.1323 L10.0005,15.7173 L14.3065,29.7593 L26.1205,26.0913 L21.8405,12.1323 Z M12.2405,31.6733 L7.2175,15.2903 C7.1655,14.9603 7.2225,14.6223 7.3795,14.3263 C7.5335,14.0533 7.7725,13.8363 8.0585,13.7073 L22.2675,9.3493 C22.9275,9.2193 23.5885,9.5703 23.8515,10.1903 L28.8745,26.5723 C29.0625,27.2403 28.6935,27.9383 28.0345,28.1563 L13.8245,32.5133 C13.5155,32.5673 13.1965,32.5203 12.9155,32.3813 C12.6195,32.2243 12.3835,31.9763 12.2405,31.6733 L12.2405,31.6733 Z",
    id: "Fill-18",
    fill: "#21445E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9567,16.975 C37.1997,18.402 35.4407,18.961 33.9997,18.234 C32.5787,17.444 32.0357,15.673 32.7697,14.222 C33.5557,12.812 35.3257,12.289 36.7517,13.047 C38.1697,13.799 38.7087,15.558 37.9567,16.975 L37.9567,16.975 Z M2.8897,14.743 C2.8857,14.731 2.8817,14.719 2.8777,14.707 C2.4877,13.398 3.2317,12.021 4.5407,11.631 L30.8697,3.557 C31.4947,3.384 32.1597,3.439 32.7467,3.713 L32.8017,3.742 L45.8137,11.137 L40.0467,12.905 C39.5287,12.046 38.7927,11.341 37.9107,10.862 C37.8757,10.843 37.8387,10.824 37.8027,10.805 C35.1327,9.427 31.8517,10.474 30.4737,13.143 C29.0947,15.813 30.1427,19.095 32.8107,20.473 C35.4807,21.851 38.7627,20.804 40.1417,18.134 C40.6027,17.244 40.8177,16.247 40.7647,15.246 L46.5317,13.477 L39.9307,26.84 C39.6147,27.456 39.0657,27.921 38.4057,28.131 L12.0757,36.204 C10.7667,36.55 9.4117,35.831 8.9637,34.553 L2.8897,14.743 Z M3.7157,9.323 C1.1457,10.143 -0.2723,12.892 0.5487,15.461 L6.6237,35.27 C6.6337,35.307 6.6447,35.342 6.6557,35.378 C7.4767,37.948 10.2247,39.366 12.7937,38.545 L39.1237,30.471 C40.4337,30.077 41.5237,29.164 42.1437,27.945 L49.0057,14.09 C49.2507,13.634 49.3767,13.123 49.3737,12.605 L55.7267,10.658 C56.2237,10.424 56.5067,9.89 56.4217,9.347 C56.3147,8.672 55.6837,8.211 55.0087,8.317 L48.6557,10.265 C48.3687,9.834 47.9777,9.482 47.5197,9.242 L34.0697,1.616 C32.8737,0.953 31.4577,0.809 30.1517,1.217 L3.8227,9.29 C3.7867,9.301 3.7517,9.312 3.7157,9.323 L3.7157,9.323 Z",
    id: "Fill-20",
    fill: "#21445E"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-22",
    fill: "#3FA9F5",
    points: "21.8259 12.0634 9.9859 15.6484 14.2919 29.6904 26.1059 26.0224"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyTagsIcon);
export default __webpack_public_path__ + "static/media/Empty_Tags_Icon.31a236fd12f87c4fbbd717df2d296b05.svg";
export { ForwardRef as ReactComponent };